import React from 'react'

import { TableHeaderProps } from '../../types'
import TableCell from '../TableCell/index'
import './style.scss'

const TableHeader = ({
  sortCountries,
  isNameReversing,
  isPopReversing,
  isRegionReversing,
}: TableHeaderProps) => {
  return (
    <TableCell
      sortCountries={sortCountries}
      isNameReversing={isNameReversing}
      isPopReversing={isPopReversing}
      isRegionReversing={isRegionReversing}
    />
  )
}

export default TableHeader
